import webshop from '@wwdev/webshop';
import Checkout from "@wwdev/webshop/checkout";
import Bindings from "@wwdev/webshop/bindings";
import Variants from "@wwdev/webshop/variants";
import Popup from '@wwdev/webshop/popup';
import Login from '@wwdev/winkelwagen/v2/login';
import "@wwdev/winkelwagen/form";
import "@wwdev/product"

webshop.basket.init();
webshop.shipping.init();

(new Popup()).init();
new Login();

Checkout.init();

Bindings.init();

Variants.init();
